import type { PropsValue } from 'react-select';
import { Radio, RadioGroup } from '@ksyos/design-system';
import { getEnumSelectOptions } from '../../utils/getEnumSelectOptions';

type EnumRadioGroupProps<EnumType extends Record<string, string>> = {
    enumObj: EnumType;
    error?: string;
    id?: string;
    labels: Record<keyof EnumType, string>;
    onChange: (value: keyof EnumType) => void;
    sortByLabel?: boolean;
    value?: PropsValue<keyof EnumType>;
};

export function EnumRadioGroup<EnumType extends Record<string, string>>({
    enumObj,
    error,
    labels,
    onChange,
    id,
    sortByLabel = true,
    value,
}: Readonly<EnumRadioGroupProps<EnumType>>) {
    const options: { label: string; value: keyof EnumType }[] = getEnumSelectOptions(enumObj, labels, sortByLabel);

    return (
        <RadioGroup
            error={error}
            id={id}
            onChange={(event) => onChange(event.target.value as keyof EnumType)}
            value={String(value)}
        >
            {options.map((option) => (
                <Radio
                    key={String(option.value)}
                    label={option.label}
                    value={String(option.value)}
                />
            ))}
        </RadioGroup>
    );
}
